import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Page,
  Card,
  PageActions,
  Text,
  Loading,
  Checkbox,
  FormLayout,
  TextField,
  InlineError,
  Toast,
  Button,
  Form,
  DropZone,
  Stack,
  Thumbnail,
  BlockStack,
  Modal,
  Spinner,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { NoteIcon } from "@shopify/polaris-icons";
import LoadingScreen from "../../Components/LoadingScreen";
import ProgressBar from "../../Components/ProgressBar";
import EllipsisText from "react-ellipsis-text";
import { FileIcon } from "@shopify/polaris-icons";
import JoditEditor from "jodit-react";
import { EDITOR_CONFIG } from "../../constants";
import { MultiSelect } from "react-multi-select-component";
import axios2 from "axios";

const AddEditProfessor = (props) => {
  const navigate = useNavigate();
  const editor = useRef(null);
  const { id } = useParams();
  const [isSaving, setIsSaving] = useState(
    props.type === "edit" ? true : false
  );
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [isVideoUploading, setIsVideoUploading] = useState(false);
  const [progressNumber, setProgressNumber] = useState(0);

  const [imagePreview, setImagePreview] = useState("");
  const [item, setItem] = useState({
    jobAr: "",
    jobEn: "",
    nameAr: "",
    nameEn: "",
    descriptionEn: "",
    descriptionAr: "",
    isActive: true,
    hourlyRate: "",
    videoTitleAr: "",
    videoTitleEn: "",
  });
  const handleChangeHourlyRate = (newValue) => {
    setItem({ ...item, hourlyRate: newValue });
  };
  const handleChangeNameEn = (newValue) => {
    setItem({ ...item, nameEn: newValue });
    setNameEnError("");
  };
  const [nameEnError, setNameEnError] = useState("");

  const handleChangeNameAr = (newValue) => {
    setItem({ ...item, nameAr: newValue });
    setNameArError("");
  };
  const [nameArError, setNameArError] = useState("");

  const handleChangeJobEn = (newValue) => {
    setItem({ ...item, jobEn: newValue });
    setJobEnError("");
  };
  const [jobEnError, setJobEnError] = useState("");
  const handleChangeJobAr = (newValue) => {
    setItem({ ...item, jobAr: newValue });
    setJobArError("");
  };
  const [jobArError, setJobArError] = useState("");
  const handleChangeDescriptionEn = (newValue) => {
    setItem({ ...item, descriptionEn: newValue });
  };
  const handleChangeDescriptionAr = (newValue) => {
    setItem({ ...item, descriptionAr: newValue });
  };
  const handleChangeActive = (newValue) => {
    setItem({ ...item, isActive: newValue });
  };
  const handleChangeVideoTitleEn = (newValue) => {
    setItem({ ...item, videoTitleEn: newValue });
  };
  const handleChangeVideoTitleAr = (newValue) => {
    setItem({ ...item, videoTitleAr: newValue });
  };
  const [files, setFiles] = useState([]);
  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFiles((files) => [...files, ...acceptedFiles]),
    []
  );
  const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
  const fileUpload = !files.length && (
    <DropZone.FileUpload
      actionHint={"Accepts pngs and jpegs (Required size: 720x1080 pixels)"}
    />
  );
  const uploadedFiles = files.length > 0 && (
    <div style={{ padding: "0" }}>
      <div className="rowDiv">
        <Thumbnail
          size="small"
          source={
            validImageTypes.includes(files[files.length - 1].type)
              ? window.URL.createObjectURL(files[files.length - 1])
              : NoteIcon
          }
        />
        <div>
          {files[files.length - 1].name}{" "}
          <Text variant="bodySm" as="p">
            {files[files.length - 1].size} bytes
          </Text>
        </div>
      </div>
    </div>
  );
  const sendImage = (files) => {
    setItem({
      ...item,
      image:
        validImageTypes.indexOf(files[files.length - 1].type) > 0
          ? window.URL.createObjectURL(files[files.length - 1])
          : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
    });
    setImageError("");
  };
  const [imageError, setImageError] = useState("");
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;
  const [filesVideo, setFilesVideo] = useState([]);
  const handleDropZoneDropVideo = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFilesVideo((filesVideo) => [...filesVideo, ...acceptedFiles]),
    []
  );
  const fileUploadVideo = !filesVideo.length && (
    <DropZone.FileUpload actionHint={"Accepts mp4 and mov"} />
  );
  const uploadedFilesVideo = filesVideo.length > 0 && (
    <div style={{ padding: "0" }}>
      {filesVideo.map((file, index) => (
        <div key={index} className="rowDiv">
          <Thumbnail
            size="small"
            alt={file.name}
            source={
              validImageTypes.includes(file.type)
                ? window.URL.createObjectURL(file)
                : NoteIcon
            }
          />
          <div>
            {file.name}{" "}
            <Text variant="bodySm" as="p">
              {file.size} bytes
            </Text>
          </div>
        </div>
      ))}
    </div>
  );
  const videoKey = useRef("");

  const sendImageVideo = (filesVideo) => {
    // setItem({
    //   ...item,
    //   video:
    //     validImageTypes.indexOf(filesVideo[filesVideo.length - 1].type) > 0
    //       ? window.URL.createObjectURL(filesVideo[filesVideo.length - 1])
    //       : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
    // });

    setIsVideoUploading(true);
    let url2 = "";
    const form_data = new FormData();
    form_data.append("file_name", filesVideo[filesVideo.length - 1].name);
    form_data.append("content_type", filesVideo[filesVideo.length - 1].type);
    axios
      .post("/generate-presigned-url", form_data)
      .then((res) => {
        videoKey.current = res.data.key;
        url2 = res.data.url;

        axios2
          .put(url2, filesVideo[filesVideo.length - 1], {
            headers: {
              "Content-Type": filesVideo[filesVideo.length - 1].type,
            },
            onUploadProgress: (progressEvent) => {
              // Calculate the percentage of upload progress
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              console.log(`Upload progress: ${percentCompleted}%`);
              setProgressNumber(`${percentCompleted}`);
              // You can also update a state here if you are using React for a progress bar
              // setUploadProgress(percentCompleted);
            },
          })
          .then((res) => {
            setIsVideoUploading(false);
            setItem({
              ...item,
              video:
                validImageTypes.indexOf(
                  filesVideo[filesVideo.length - 1].type
                ) > 0
                  ? window.URL.createObjectURL(
                      filesVideo[filesVideo.length - 1]
                    )
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            });
          })
          .catch((error) => {
            if (error.response) {
              console.error("Status:", error.response.status);
              console.error(
                "Headers:",
                JSON.stringify(error.response.headers, null, 2)
              );
              console.error("Data:", error.response.data);
            } else {
              console.error("Error Message:", error.message);
            }
          });
      })
      .catch((err) => console.log(""));
  };
  const [optionsSubjects, setOptionsSubjects] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [subjectsError, setSubjectsError] = useState("");

  useEffect(() => {
    fetchData();
  }, []);
  async function fetchData() {
    let responseSubjects = "";
    let responseItem = "";

    try {
      responseSubjects = await axios.get(`/subjects`);
      setOptionsSubjects(
        responseSubjects.data.data.data.map((item, index) => {
          return {
            label: item?.name && getFirstNonNullValue(item.name),
            value: String(item.id),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }

    if (props?.type === "edit")
      try {
        responseItem = await axios.get(`/professors/${id}`);
        setItem({
          nameEn:
            responseItem?.data?.data?.name && responseItem?.data?.data?.name?.en
              ? responseItem.data.data.name.en
              : "",
          nameAr:
            responseItem?.data?.data?.name && responseItem?.data?.data?.name?.ar
              ? responseItem.data.data.name.ar
              : "",
          hourlyRate:
            responseItem?.data?.data?.hourly_rate !== null
              ? String(responseItem.data.data.hourly_rate)
              : "",
          descriptionEn:
            responseItem?.data?.data?.description &&
            responseItem?.data?.data?.description?.en
              ? responseItem.data.data.description.en
              : "",
          descriptionAr:
            responseItem?.data?.data?.description &&
            responseItem?.data?.data?.description?.ar
              ? responseItem.data.data.description.ar
              : "",
          jobEn:
            responseItem?.data?.data?.job_title &&
            responseItem?.data?.data?.job_title?.en
              ? responseItem.data.data.job_title.en
              : "",
          jobAr:
            responseItem?.data?.data?.job_title &&
            responseItem?.data?.data?.job_title?.ar
              ? responseItem.data.data.job_title.ar
              : "",
          image: responseItem?.data?.data?.image
            ? responseItem.data.data.image
            : "",
          videoTitleEn:
            responseItem?.data?.data?.trial_video_title &&
            responseItem?.data?.data?.trial_video_title?.en
              ? responseItem.data.data.trial_video_title.en
              : "",
          videoTitleAr:
            responseItem?.data?.data?.trial_video_title &&
            responseItem?.data?.data?.trial_video_title?.ar
              ? responseItem.data.data.trial_video_title.ar
              : "",
          video: responseItem?.data?.data?.trial_video
            ? "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304"
            : "",
          isActive: responseItem?.data?.data?.is_active ? true : false,
        });
        setSelectedSubjects(
          responseItem?.data?.data?.subjects?.map((item, index) => {
            return {
              label: getFirstNonNullValue(item.name),
              value: String(item.id),
            };
          })
        );
        setIsSaving(false);
      } catch (error) {
        console.log(error);
      }
  }
  // useEffect(() => {
  //   props.type === "edit" &&
  //     axios
  //       .get(`/professors/${id}`)
  //       .then((result) => {
  //         console.log(result.data.data);
  //         setItem({
  //           nameEn:
  //             result?.data?.data?.name && result?.data?.data?.name?.en
  //               ? result.data.data.name.en
  //               : "",
  //           nameAr:
  //             result?.data?.data?.name && result?.data?.data?.name?.ar
  //               ? result.data.data.name.ar
  //               : "",
  //           hourlyRate:
  //             result?.data?.data?.hourly_rate !== null
  //               ? String(result.data.data.hourly_rate)
  //               : "",
  //           descriptionEn:
  //             result?.data?.data?.description &&
  //             result?.data?.data?.description?.en
  //               ? result.data.data.description.en
  //               : "",
  //           descriptionAr:
  //             result?.data?.data?.description &&
  //             result?.data?.data?.description?.ar
  //               ? result.data.data.description.ar
  //               : "",
  //           jobEn:
  //             result?.data?.data?.subject_title &&
  //             result?.data?.data?.subject_title?.en
  //               ? result.data.data.subject_title.en
  //               : "",
  //           jobAr:
  //             result?.data?.data?.subject_title &&
  //             result?.data?.data?.subject_title?.ar
  //               ? result.data.data.subject_title.ar
  //               : "",
  //           image: result?.data?.data?.image ? result.data.data.image : "",
  //           videoTitleEn:
  //             result?.data?.data?.trial_video_title &&
  //             result?.data?.data?.trial_video_title?.en
  //               ? result.data.data.trial_video_title.en
  //               : "",
  //           videoTitleAr:
  //             result?.data?.data?.trial_video_title &&
  //             result?.data?.data?.trial_video_title?.ar
  //               ? result.data.data.trial_video_title.ar
  //               : "",
  //           video: result?.data?.data?.trial_video
  //             ? result.data.data.trial_video
  //             : "",
  //           isActive: result?.data?.data?.is_active ? true : false,
  //         });
  //         setIsSaving(false);
  //       })

  //       .catch((err) => console.log(err));
  // }, []);
  const refId = useRef(null);
  const [activeDelete, setActiveDelete] = useState(false);
  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleDelete = (id) => {
    refId.current = id;
    setActiveDelete(true);
  };
  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`/professors/${id}`)
      .then((result) => {
        navigate("/admin/professors");
      })
      .catch((err) => console.log(err));
  };
  return (
    <Page
      title={`${props.type === "add" ? "Add" : "Edit"} Professor`}
      backAction={{ onAction: () => navigate("/admin/professors") }}
      narrowWidth
    >
      {isSaving ? <Loading /> : null}

      <Card sectioned>
        <FormLayout>
          <Text as="h2" variant="headingSm">
            Resume
          </Text>
          <FormLayout.Group>
            <TextField
              value={item.nameEn}
              onChange={handleChangeNameEn}
              label="Name En"
              error={nameEnError}
              requiredIndicator
            />
            <TextField
              value={item.nameAr}
              onChange={handleChangeNameAr}
              label="Name Ar"
              align="right"
              requiredIndicator
              error={nameArError}
            />
          </FormLayout.Group>

          <FormLayout.Group>
            <TextField
              value={item.jobEn}
              onChange={handleChangeJobEn}
              label="Job Title En"
              requiredIndicator
              error={jobEnError}
            />
            <TextField
              value={item.jobAr}
              onChange={handleChangeJobAr}
              label="Job Title Ar"
              align="right"
              requiredIndicator
              error={jobArError}
            />
          </FormLayout.Group>
          <TextField
            value={item.hourlyRate}
            onChange={handleChangeHourlyRate}
            label="Hourly rate"
          />
          <Text>Subjects</Text>
          <div style={{ position: "relative", zIndex: 9999 }}>
            <MultiSelect
              options={optionsSubjects}
              onChange={setSelectedSubjects}
              value={selectedSubjects}
              placeholder="Please select"
            />
          </div>
          <InlineError message={subjectsError} />
          <Text>Description En</Text>
          <JoditEditor
            ref={editor}
            value={item.descriptionEn}
            config={EDITOR_CONFIG}
            onBlur={handleChangeDescriptionEn}
          />

          <Text>Description Ar</Text>
          <JoditEditor
            ref={editor}
            value={item.descriptionAr}
            config={EDITOR_CONFIG}
            onBlur={handleChangeDescriptionAr}
          />
          <Text>
            Image <span style={{ color: "#8e1f0b" }}>*</span>
          </Text>

          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div>
              <Thumbnail size="large" source={item.image ? item.image : ""} />
            </div>
            <div
              style={{
                width: "100%",
                marginLeft: "10px",
              }}
            >
              <DropZone
                accept=".jpeg,.png,.jpg"
                onDrop={handleDropZoneDrop}
                allowMultiple={false}
                onDropAccepted={sendImage}
              >
                {uploadedFiles}
                {fileUpload}
              </DropZone>
            </div>
          </div>
          <InlineError message={imageError} />
          <Text as="h2" variant="headingSm">
            Trial Video
          </Text>
          <FormLayout.Group>
            <TextField
              value={item.videoTitleEn}
              onChange={handleChangeVideoTitleEn}
              label="Video Title En"
            />
            <TextField
              value={item.videoTitleAr}
              onChange={handleChangeVideoTitleAr}
              label="Video Title Ar"
            />
          </FormLayout.Group>

          <Text>Video</Text>

          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div>
              <Thumbnail size="large" source={item?.video ? item?.video : ""} />
            </div>
            <div
              style={{
                width: "100%",
                marginLeft: "10px",
              }}
            >
              <DropZone
                accept=".mp4,.mov"
                onDrop={handleDropZoneDropVideo}
                allowMultiple={false}
                onDropAccepted={sendImageVideo}
              >
                {uploadedFilesVideo}
                {fileUploadVideo}
              </DropZone>
            </div>
          </div>
          <Checkbox
            label="Is active"
            checked={item.isActive}
            onChange={handleChangeActive}
          />
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={
          <Button variant="primary" onClick={handleSave}>
            {isSaving ? <Spinner size="small" /> : "Save"}
          </Button>
        }
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              tone="critical"
              onClick={() => setActiveDelete(true)}
            >
              {isSaving ? <Spinner size="small" /> : "Delete"}
            </Button>
          )
        }
      />
      {/* <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              loading={isSaving}
              tone="critical"
              onClick={() => {
                setIsSaving(true);
                axios
                  .delete(`/professors/${id}`)
                  .then((result) => {
                    navigate("/admin/professors");
                  })
                  .catch((err) => console.log(err));
              }}
            >
              Delete
            </Button>
          )
        }
      /> */}
      <Modal
        open={activeDelete}
        onClose={handleChangeModalDelete}
        title="Delete Item"
        primaryAction={{
          content: "Yes",
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalDelete,
          },
        ]}
      >
        <Modal.Section>
          <Text>
            <p>Are you sure you want to delete this item?</p>
          </Text>
        </Modal.Section>
      </Modal>
      {toastMarkup}
      {isVideoUploading ? <ProgressBar progress={progressNumber} /> : null}
    </Page>
  );

  function handleSave() {
    if (
      !item.nameEn ||
      !item.nameAr ||
      (props?.type === "add" && !files?.length) ||
      !selectedSubjects.length ||
      !item.jobEn ||
      !item.jobAr
    ) {
      !item.nameEn && setNameEnError("This field is required");
      !item.nameAr && setNameArError("This field is required");
      !item.jobEn && setJobEnError("This field is required");
      !item.jobAr && setJobArError("This field is required");
      props?.type === "add" &&
        !files?.length &&
        setImageError("Please upload an image");
      !selectedSubjects.length &&
        setSubjectsError("Please select at least one subject");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      form_data.append("hourly_rate", item.hourlyRate);
      item.nameEn && form_data.append("name[en]", item.nameEn);
      item.nameAr && form_data.append("name[ar]", item.nameAr);
      item.jobEn && form_data.append("job_title[en]", item.jobEn);
      item.jobAr && form_data.append("job_title[ar]", item.jobAr);
      item.descriptionEn &&
        form_data.append("description[en]", item.descriptionEn);
      item.descriptionAr &&
        form_data.append("description[ar]", item.descriptionAr);
      item.videoTitleEn &&
        form_data.append("trial_video_title[en]", item.videoTitleEn);
      item.videoTitleAr &&
        form_data.append("trial_video_title[ar]", item.videoTitleAr);
      videoKey.current && form_data.append("trial_video", videoKey.current);
      // filesVideo?.length && form_data.append("trial_video", filesVideo[0]);
      files?.length && form_data.append("image", files[0]);
      form_data.append("is_active", item.isActive ? 1 : 0);
      props?.type === "edit" && form_data.append("_method", "PATCH");
      selectedSubjects.forEach((selectedSubject, index) =>
        form_data.append(`subject_ids[${index}]`, selectedSubject.value)
      );
      props.type === "add"
        ? axios
            .post(`/professors`, form_data)
            .then((result) => {
              navigate("/admin/professors");
            })
            .catch((err) => console.log(err))
        : axios
            .post(`/professors/${id}`, form_data)
            .then((result) => {
              navigate("/admin/professors");
              // toggleActive();
              // setIsSaving(false);
            })
            .catch((err) => console.log(err));
    }
  }
  function getFirstNonNullValue(obj) {
    for (const value of Object.values(obj)) {
      if (value !== null) {
        return value;
      }
    }
    return null;
  }
};

export default AddEditProfessor;
